module.exports = __webpack_public_path__ + "img/1.93591801.png";